import { CheckCanAccessDiscoverMoreUseCase } from './CheckCanAccessDiscoverMoreUseCase'

export const checkCanAccessDiscoverMoreUseCase =
  new CheckCanAccessDiscoverMoreUseCase().execute

export {
  CheckCanAccessDiscoverMoreUseCase,
  type CheckCanAccessDiscoverMoreParams,
} from './CheckCanAccessDiscoverMoreUseCase'
